import { DownOutlined } from "@ant-design/icons";
import { Button, Table } from "antd";
import clsx from "clsx";
import { useState } from "react";

import "./ResponseAggregates.css";

type Props = {
  data: any[];
  columns: any[];
  fullWidth?: boolean;
  fullHeightAllowed?: boolean;
  paywall?: boolean;
};

export default function ScrollableTable({
  data,
  columns,
  fullWidth = true,
  fullHeightAllowed = false,
  paywall = true,
}: Props) {
  const [showFullTable, setShowFullTable] = useState(false);
  return (
    <div className="relative flex-1">
      <div
        className={clsx("overflow-y-scroll rounded-lg border border-gray-100", {
          "w-full": fullWidth,
          "max-h-72": !fullHeightAllowed || !showFullTable,
          auto: showFullTable,
        })}
        style={{ minWidth: "300px" }}
      >
        {paywall ? (
          <div className="h-56 relative">
            <div className="w-full h-full flex items-center flex-col justify-center bg-white z-20 absolute left-0 top-0 bg-opacity-80">
              <p className="m-0 font-semibold">Drop-off rate</p>
              <p className="m-0 text-xl">
                Find out exactly where you're losing people
              </p>
              <p className=" text-dots-dark-orange font-semibold m-2">
                Available on Business plan
              </p>
              <Button
                type="primary"
                size="large"
                shape="round"
                href="/settings"
              >
                Click here to upgrade
              </Button>
            </div>
            <div className="h-2 w-24 bg-dots-vibrant-orange top-10 left-10 absolute z-10 rounded-full" />
            <div className="h-2 w-40 bg-gray-300 top-14 right-72 absolute z-10 rounded-full" />
            <div className="h-2 w-16 bg-yellow-200 top-3 right-0 absolute z-10" />
            <div className="h-2 w-36 bg-yellow-300 top-16 left-64 absolute z-10" />
            <div className="h-2 w-24 bg-dots-yellow top-20 right-20 absolute z-10" />
            <div className="h-2 w-12 bg-dots-vibrant-orange top-36 right-10 absolute z-10 rounded-full" />
            <div className="h-2 w-28 bg-dots-vibrant-orange top-36 right-32 absolute z-10" />
            <div className="h-2 w-24 bg-yellow-300 bottom-14 left-20 absolute z-10" />
            <div className="h-2 w-20 bg-gray-300 top-44 left-3 absolute z-10" />
            <div className="h-2 w-24 bg-dots-vibrant-orange bottom-20 left-60 absolute z-10" />
            <div className="h-2 w-36 bg-gray-300 bottom-3 left-96 absolute z-10 rounded-full" />
            <div className="h-2 w-36 bg-gray-400 bottom-6 right-96 absolute z-10" />
          </div>
        ) : (
          <>
            <Table
              dataSource={data}
              columns={columns}
              pagination={
                data.length > 100
                  ? {
                      defaultPageSize: 100,
                      simple: true,
                    }
                  : false
              }
            />
            {fullHeightAllowed && !showFullTable && data.length > 3 && (
              <div
                className="absolute bottom-0 w-full scroll-table-gradient h-14 cursor-pointer"
                onClick={() => {
                  setShowFullTable(!showFullTable);
                }}
              >
                <DownOutlined
                  style={{
                    color: "#3b3b3b",
                    fontSize: "18px",
                    marginTop: "23px",
                  }}
                />
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
